export const KioskLogo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="100%"
      height="100%"
      viewBox="0 0 546 726"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_7755_13945)">
        <g clipPath="url(#clip0_7755_13945)">
          <rect
            x="103.878"
            y="98"
            width="375"
            height="500"
            rx="20"
            transform="rotate(4 103.878 98)"
            fill="white"
          />
          <rect
            x="113.617"
            y="130.759"
            width="109"
            height="73"
            rx="5"
            transform="rotate(4 113.617 130.759)"
            fill="#FFE2E2"
          />
          <rect
            x="108.176"
            y="208.569"
            width="65"
            height="5"
            rx="2.5"
            transform="rotate(4 108.176 208.569)"
            fill="#9AA9A3"
          />
          <rect
            x="107.479"
            y="218.545"
            width="24"
            height="5"
            rx="2.5"
            transform="rotate(4 107.479 218.545)"
            fill="#5E786D"
          />
          <path
            d="M233.761 147.23C233.959 144.389 234.059 142.969 234.696 141.927C235.233 141.049 236.027 140.359 236.972 139.949C238.092 139.463 239.512 139.562 242.353 139.761L335.026 146.241C337.867 146.44 339.287 146.539 340.329 147.176C341.207 147.713 341.898 148.508 342.307 149.452C342.793 150.573 342.694 151.993 342.495 154.833L338.526 211.595C338.327 214.435 338.228 215.855 337.591 216.897C337.054 217.775 336.259 218.466 335.315 218.876C334.195 219.362 332.775 219.262 329.934 219.064L237.26 212.583C234.42 212.385 233 212.285 231.958 211.648C231.08 211.111 230.389 210.316 229.98 209.372C229.494 208.252 229.593 206.832 229.792 203.991L233.761 147.23Z"
            fill="#FAE8FF"
          />
          <rect
            x="228.881"
            y="217.01"
            width="65"
            height="5"
            rx="2.5"
            transform="rotate(4 228.881 217.01)"
            fill="#9AA9A3"
          />
          <rect
            x="228.184"
            y="226.985"
            width="24"
            height="5"
            rx="2.5"
            transform="rotate(4 228.184 226.985)"
            fill="#5E786D"
          />
          <path
            d="M354.466 155.671C354.665 152.83 354.764 151.41 355.401 150.368C355.938 149.49 356.733 148.799 357.677 148.39C358.797 147.904 360.218 148.003 363.058 148.202L455.732 154.682C458.572 154.881 459.993 154.98 461.035 155.617C461.912 156.154 462.603 156.949 463.013 157.893C463.499 159.013 463.399 160.433 463.201 163.274L459.232 220.035C459.033 222.876 458.934 224.296 458.297 225.338C457.76 226.216 456.965 226.907 456.021 227.316C454.901 227.802 453.48 227.703 450.64 227.504L357.966 221.024C355.125 220.825 353.705 220.726 352.663 220.089C351.786 219.552 351.095 218.757 350.685 217.813C350.199 216.693 350.299 215.272 350.497 212.432L354.466 155.671Z"
            fill="#D0FAE5"
          />
          <rect
            x="349.587"
            y="225.45"
            width="65"
            height="5"
            rx="2.5"
            transform="rotate(4 349.587 225.45)"
            fill="#9AA9A3"
          />
          <rect
            x="348.89"
            y="235.426"
            width="24"
            height="5"
            rx="2.5"
            transform="rotate(4 348.89 235.426)"
            fill="#5E786D"
          />
          <path
            d="M105.173 251.514C105.371 248.674 105.471 247.254 106.108 246.212C106.645 245.334 107.44 244.643 108.384 244.233C109.504 243.747 110.924 243.847 113.765 244.045L206.438 250.526C209.279 250.724 210.699 250.824 211.741 251.461C212.619 251.998 213.31 252.793 213.719 253.737C214.205 254.857 214.106 256.277 213.907 259.118L209.938 315.879C209.74 318.72 209.64 320.14 209.003 321.182C208.466 322.06 207.671 322.75 206.727 323.16C205.607 323.646 204.187 323.547 201.346 323.348L108.673 316.868C105.832 316.669 104.412 316.57 103.37 315.933C102.492 315.396 101.801 314.601 101.392 313.657C100.906 312.536 101.005 311.116 101.204 308.276L105.173 251.514Z"
            fill="#FEF9C2"
          />
          <rect
            x="100.293"
            y="321.294"
            width="65"
            height="5"
            rx="2.5"
            transform="rotate(4 100.293 321.294)"
            fill="#9AA9A3"
          />
          <rect
            x="99.5962"
            y="331.27"
            width="24"
            height="5"
            rx="2.5"
            transform="rotate(4 99.5962 331.27)"
            fill="#5E786D"
          />
          <path
            d="M225.878 259.955C226.077 257.114 226.176 255.694 226.813 254.652C227.35 253.774 228.145 253.083 229.089 252.674C230.209 252.188 231.629 252.287 234.47 252.486L327.144 258.966C329.984 259.165 331.404 259.264 332.446 259.901C333.324 260.438 334.015 261.233 334.424 262.177C334.91 263.297 334.811 264.718 334.612 267.558L330.643 324.32C330.445 327.16 330.345 328.58 329.708 329.622C329.171 330.5 328.377 331.191 327.432 331.6C326.312 332.086 324.892 331.987 322.051 331.788L229.378 325.308C226.537 325.109 225.117 325.01 224.075 324.373C223.197 323.836 222.506 323.041 222.097 322.097C221.611 320.977 221.71 319.557 221.909 316.716L225.878 259.955Z"
            fill="#ECFCCA"
          />
          <rect
            x="220.999"
            y="329.734"
            width="65"
            height="5"
            rx="2.5"
            transform="rotate(4 220.999 329.734)"
            fill="#9AA9A3"
          />
          <rect
            x="220.301"
            y="339.71"
            width="24"
            height="5"
            rx="2.5"
            transform="rotate(4 220.301 339.71)"
            fill="#5E786D"
          />
          <path
            d="M346.583 268.395C346.782 265.555 346.881 264.135 347.519 263.093C348.056 262.215 348.85 261.524 349.794 261.115C350.915 260.629 352.335 260.728 355.175 260.927L447.849 267.407C450.69 267.606 452.11 267.705 453.152 268.342C454.03 268.879 454.72 269.674 455.13 270.618C455.616 271.738 455.517 273.158 455.318 275.999L451.349 332.76C451.15 335.601 451.051 337.021 450.414 338.063C449.877 338.941 449.082 339.632 448.138 340.041C447.018 340.527 445.597 340.428 442.757 340.229L350.083 333.749C347.243 333.55 345.822 333.451 344.781 332.814C343.903 332.277 343.212 331.482 342.802 330.538C342.316 329.418 342.416 327.997 342.614 325.157L346.583 268.395Z"
            fill="#E0E7FF"
          />
          <rect
            x="341.704"
            y="338.175"
            width="65"
            height="5"
            rx="2.5"
            transform="rotate(4 341.704 338.175)"
            fill="#9AA9A3"
          />
          <rect
            x="341.007"
            y="348.151"
            width="24"
            height="5"
            rx="2.5"
            transform="rotate(4 341.007 348.151)"
            fill="#5E786D"
          />
          <path
            d="M97.2905 364.239C97.4891 361.398 97.5885 359.978 98.2256 358.936C98.7625 358.058 99.5573 357.368 100.501 356.958C101.622 356.472 103.042 356.571 105.882 356.77L198.556 363.25C201.397 363.449 202.817 363.548 203.859 364.186C204.737 364.722 205.427 365.517 205.837 366.461C206.323 367.582 206.224 369.002 206.025 371.842L202.056 428.604C201.857 431.444 201.758 432.865 201.121 433.906C200.584 434.784 199.789 435.475 198.845 435.885C197.725 436.371 196.304 436.271 193.464 436.073L100.79 429.592C97.9497 429.394 96.5294 429.294 95.4877 428.657C94.6098 428.12 93.9189 427.325 93.5094 426.381C93.0234 425.261 93.1227 423.841 93.3214 421L97.2905 364.239Z"
            fill="#CEFAFE"
          />
          <rect
            x="92.4111"
            y="434.019"
            width="65"
            height="5"
            rx="2.5"
            transform="rotate(4 92.4111 434.019)"
            fill="#9AA9A3"
          />
          <rect
            x="91.7139"
            y="443.994"
            width="24"
            height="5"
            rx="2.5"
            transform="rotate(4 91.7139 443.994)"
            fill="#5E786D"
          />
          <path
            d="M217.996 372.679C218.194 369.839 218.294 368.419 218.931 367.377C219.468 366.499 220.262 365.808 221.206 365.398C222.327 364.913 223.747 365.012 226.588 365.21L319.261 371.691C322.102 371.889 323.522 371.989 324.564 372.626C325.442 373.163 326.133 373.958 326.542 374.902C327.028 376.022 326.929 377.442 326.73 380.283L322.761 437.044C322.562 439.885 322.463 441.305 321.826 442.347C321.289 443.225 320.494 443.915 319.55 444.325C318.43 444.811 317.01 444.712 314.169 444.513L221.495 438.033C218.655 437.834 217.235 437.735 216.193 437.098C215.315 436.561 214.624 435.766 214.214 434.822C213.729 433.701 213.828 432.281 214.026 429.441L217.996 372.679Z"
            fill="#FFEDD4"
          />
          <rect
            x="213.116"
            y="442.459"
            width="65"
            height="5"
            rx="2.5"
            transform="rotate(4 213.116 442.459)"
            fill="#9AA9A3"
          />
          <rect
            x="212.419"
            y="452.435"
            width="24"
            height="5"
            rx="2.5"
            transform="rotate(4 212.419 452.435)"
            fill="#5E786D"
          />
          <path
            d="M338.701 381.12C338.9 378.279 338.999 376.859 339.636 375.817C340.173 374.94 340.968 374.249 341.912 373.839C343.032 373.353 344.453 373.453 347.293 373.651L439.967 380.132C442.807 380.33 444.228 380.429 445.269 381.067C446.147 381.604 446.838 382.398 447.248 383.342C447.734 384.463 447.634 385.883 447.436 388.723L443.467 445.485C443.268 448.325 443.169 449.746 442.531 450.787C441.995 451.665 441.2 452.356 440.256 452.766C439.135 453.252 437.715 453.152 434.875 452.954L342.201 446.473C339.36 446.275 337.94 446.175 336.898 445.538C336.02 445.001 335.33 444.207 334.92 443.262C334.434 442.142 334.533 440.722 334.732 437.881L338.701 381.12Z"
            fill="#FFE2E2"
          />
          <rect
            x="333.822"
            y="450.9"
            width="65"
            height="5"
            rx="2.5"
            transform="rotate(4 333.822 450.9)"
            fill="#9AA9A3"
          />
          <rect
            x="333.125"
            y="460.875"
            width="24"
            height="5"
            rx="2.5"
            transform="rotate(4 333.125 460.875)"
            fill="#5E786D"
          />
          <rect
            x="89.9697"
            y="468.933"
            width="109"
            height="73"
            rx="5"
            transform="rotate(4 89.9697 468.933)"
            fill="#FFE2E2"
          />
          <rect
            x="84.5288"
            y="546.743"
            width="65"
            height="5"
            rx="2.5"
            transform="rotate(4 84.5288 546.743)"
            fill="#9AA9A3"
          />
          <rect
            x="83.8315"
            y="556.719"
            width="24"
            height="5"
            rx="2.5"
            transform="rotate(4 83.8315 556.719)"
            fill="#5E786D"
          />
          <path
            d="M210.113 485.404C210.312 482.563 210.411 481.143 211.048 480.101C211.585 479.223 212.38 478.533 213.324 478.123C214.444 477.637 215.865 477.736 218.705 477.935L311.379 484.415C314.219 484.614 315.64 484.713 316.681 485.351C317.559 485.887 318.25 486.682 318.66 487.626C319.146 488.747 319.046 490.167 318.848 493.007L314.879 549.769C314.68 552.609 314.581 554.03 313.944 555.071C313.407 555.949 312.612 556.64 311.668 557.05C310.547 557.536 309.127 557.436 306.287 557.238L213.613 550.757C210.772 550.559 209.352 550.459 208.31 549.822C207.433 549.285 206.742 548.49 206.332 547.546C205.846 546.426 205.945 545.006 206.144 542.165L210.113 485.404Z"
            fill="#FAE8FF"
          />
          <rect
            x="205.234"
            y="555.184"
            width="65"
            height="5"
            rx="2.5"
            transform="rotate(4 205.234 555.184)"
            fill="#9AA9A3"
          />
          <rect
            x="204.537"
            y="565.159"
            width="24"
            height="5"
            rx="2.5"
            transform="rotate(4 204.537 565.159)"
            fill="#5E786D"
          />
          <path
            d="M330.819 493.845C331.017 491.004 331.117 489.584 331.754 488.542C332.291 487.664 333.086 486.973 334.03 486.564C335.15 486.078 336.57 486.177 339.411 486.376L432.084 492.856C434.925 493.055 436.345 493.154 437.387 493.791C438.265 494.328 438.956 495.123 439.365 496.067C439.851 497.187 439.752 498.608 439.553 501.448L435.584 558.209C435.386 561.05 435.286 562.47 434.649 563.512C434.112 564.39 433.317 565.081 432.373 565.49C431.253 565.976 429.833 565.877 426.992 565.678L334.319 559.198C331.478 558.999 330.058 558.9 329.016 558.263C328.138 557.726 327.447 556.931 327.038 555.987C326.552 554.867 326.651 553.447 326.85 550.606L330.819 493.845Z"
            fill="#D0FAE5"
          />
          <rect
            x="325.939"
            y="563.624"
            width="65"
            height="5"
            rx="2.5"
            transform="rotate(4 325.939 563.624)"
            fill="#9AA9A3"
          />
          <rect
            x="325.242"
            y="573.6"
            width="24"
            height="5"
            rx="2.5"
            transform="rotate(4 325.242 573.6)"
            fill="#5E786D"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_dd_7755_13945"
          x="-31"
          y="0.5"
          width="608.965"
          height="724.941"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.5" />
          <feGaussianBlur stdDeviation="50" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7755_13945"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.25" />
          <feGaussianBlur stdDeviation="1.25" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_7755_13945"
            result="effect2_dropShadow_7755_13945"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_7755_13945"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_7755_13945">
          <rect
            x="103.878"
            y="98"
            width="375"
            height="500"
            rx="20"
            transform="rotate(4 103.878 98)"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
